<template>
  <div class="modal fade" :id="id" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="staticBackdrop" aria-hidden="true">
    <div class="modal-dialog">
      <form class="form">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t('financial.transactions.details') }}</h5>
            <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" @click="closeModal">
                  <span class="svg-icon svg-icon-1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                            fill="currentColor" />
                      <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                            fill="currentColor" />
                    </svg>
                  </span>
            </div>
          </div>
          <div class="modal-body">
            <h5 class="align-items-start">
              <span class="font-weight-bolder ">{{ descriptionOftransaction() }}</span>
            </h5>
            <div class="timeline timeline-6 mt-3">
              <div v-html="historicsOftransaction()"></div>
            </div>
          </div>
          <div class="modal-footer">
            <Button type="cancel" id="cancel_btn" btn-class="btn-sm me-3" size="7px 30px" btn-text="button.close" @click="closeModal"></Button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup>
import {ref, watch, defineProps} from "vue";
import Button from "@/components/Button.vue"
import {useFormatAmount} from "@/composables/formatAmount";
import i18n from "@/plugins/i18n";

const props = defineProps({
  id: {
    type: String,
    required: true
  }
})

const amountFormatter = useFormatAmount()

const transactionData = ref(null)

const model = defineModel()

watch(() => model.value, () => {
  if(model.value) {
    transactionData.value = model.value
    $('#'+props.id).modal('toggle')
  }
})

function closeModal(){
  $('#'+props.id).modal('toggle')
}

function historicsOftransaction(){
  let text = ""
  if(transactionData.value && transactionData.value.informations){
    transactionData.value.informations.forEach(data => {
      text += " <div class=\"timeline-item align-items-start\">\n" +
          " <div class=\"timeline-badge\">\n" +
          " <i class=\"fa fa-genderless text-dark icon-xl\"></i>\n" +
          " </div>\n" +
          " <div class=\"font-weight-mormal font-size-lg timeline-content  pl-3\">"

      if(data.type === 'expense'){
        text += i18n.global.t('financial.accounts.expenses') + ': ' + data.description + ' ' + i18n.global.t('financial.accounts.of') + ' ' + amountFormatter.formatNumber(data.amount) + ' ' + data.iso + ' ' + i18n.global.t('financial.accounts.of') + ' ' + data.user
      }
      if(data.type === 'advance'){
        text += i18n.global.t('financial.accounts.advance') + ': ' + data.description + ' ' + i18n.global.t('financial.accounts.of') + ' ' + amountFormatter.formatNumber(data.amount) + ' ' + data.iso + ' ' + i18n.global.t('financial.accounts.of') + ' ' + data.user
      }
      text += "</div></div>\n"
    })
  }
  return text
}

function descriptionOftransaction(){
  let text = ""
  if(transactionData.value){
    switch(transactionData.value.type){
      case 'DEBIT' :
        text +=  i18n.global.t('financial.accounts.withdrawals') + ' ' + transactionData.value.description + ' ' + i18n.global.t('financial.accounts.of') + ' ' + 
            amountFormatter.formatNumber(transactionData.value.amount * transactionData.value.rate) +
            ' ' + transactionData.value.from_account_iso
        break
      case 'CREDIT' :
        text +=  i18n.global.t('financial.accounts.deposits') + ' ' + transactionData.value.description + ' ' + i18n.global.t('financial.accounts.of') + ' ' + 
            amountFormatter.formatNumber(transactionData.value.amount * transactionData.value.rate) + ' ' +
            transactionData.value.from_account_iso
        break
      case 'TRANSFER' :
        text +=  i18n.global.t('financial.accounts.transfers') + ' ' + transactionData.value.description + ' ' + i18n.global.t('financial.accounts.of') + ' ' + 
            amountFormatter.formatNumber(transactionData.value.amount) + ' ' +
            transactionData.value.from_account_iso
        if(transactionData.value.from_account_iso !== transactionData.value.to_account_iso){
          text+= " ("+  amountFormatter.formatNumber(transactionData.value.amount * transactionData.value.rate) +
              ' ' + transactionData.value.to_account_iso +")"
        }
        if(
            !(transactionData.value.from_id === this.currentAccount &&
                transactionData.value.from_type === 'account')
        ){
          text+= ' ' + i18n.global.t('financial.accounts.from') + ' ' + transactionData.value.from_account_name + " "
        }
        if(
            !(transactionData.value.to_id === this.currentAccount &&
                transactionData.value.to_type === 'account')
        ){
          text+= ' ' + i18n.global.t('financial.accounts.to') + ' ' + transactionData.value.to_account_name + " "
        }
        break
      case 'ADVANCE' :
        text +=  i18n.global.t('financial.accounts.advance') + ' ' + transactionData.value.description + ' ' + i18n.global.t('financial.accounts.of') + ' ' + 
            amountFormatter.formatNumber(transactionData.value.amount * transactionData.value.rate) + ' ' +
            transactionData.value.from_account_iso
        break
    }

  }
  return text
}

</script>

<style scoped>
.icon-wrapper {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon-wrapper i {
  position: relative;
  font-size: 1.5em;
}

.icon-wrapper .icon-text {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 9px;
  color: white;
  margin-top: 8px;
}
</style>